import { FPAItem } from '../../infra/protected/FPA/FPAItem';

export function findItemInTree(items: FPAItem[], key: string | number): FPAItem | undefined {
    let found = items.find((item) => +item.id === +key);

    if (!found) {
        for (const item of items) {
            if (item.childItems) {
                found = findItemInTree(item.childItems, key);
            }
            if (found) {
                break;
            }
        }
    }

    return found;
}
